module.exports = "<div class=\"form-control component-songrid-control\"> {{#if unvisible}} <p class=info>权限受限</p> {{else if be_control_condition}} <p class=info>被修改条件限制</p> {{else}} {{#if popupType}} <a href=javascript:void(0); class=ui-forms-a>查看详情</a> <input type=hidden> {{else}} <div class=ui-songrid-box> <div class=songGrid></div> </div> {{#if required}} <span id=requiredLogo class=\"required form-print-icon\"></span> {{/if}} {{/if}} {{/if}} </div>";


//////////////////
// WEBPACK FOOTER
// ./app/components/form/songrid-control/songrid-control.html
// module id = 4717
// module chunks = 50